/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetProfileRelatedTeams
 */
export interface GetProfileRelatedTeams {
    /**
     * 
     * @type {string}
     * @memberof GetProfileRelatedTeams
     */
    id: string;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetProfileRelatedTeams
     */
    team: GetTeamDto;
    /**
     * 
     * @type {string}
     * @memberof GetProfileRelatedTeams
     */
    teamId: string;
}

/**
 * Check if a given object implements the GetProfileRelatedTeams interface.
 */
export function instanceOfGetProfileRelatedTeams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "team" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function GetProfileRelatedTeamsFromJSON(json: any): GetProfileRelatedTeams {
    return GetProfileRelatedTeamsFromJSONTyped(json, false);
}

export function GetProfileRelatedTeamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProfileRelatedTeams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'team': GetTeamDtoFromJSON(json['team']),
        'teamId': json['teamId'],
    };
}

export function GetProfileRelatedTeamsToJSON(value?: GetProfileRelatedTeams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'team': GetTeamDtoToJSON(value.team),
        'teamId': value.teamId,
    };
}

